import { useSyncExternalStore } from 'react';

type voidFn = () => void;

const listeners = new Set<voidFn>();
let globalTitle = '';

function setTitle(title: string) {
  globalTitle = title;
  emitChange();
}

/** external store helpers */

function getSnapshot() {
  return globalTitle;
}

function getServerSnapshot() {
  return '';
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function emitChange() {
  listeners.forEach((listener) => listener());
}

/**
 * Hook that sets and listens to a global title variable
 */
export function useTitle() {
  const title = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return { title, setTitle };
}
